
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.001 16.541a.75.75 0 01-.75-.75V3.751a.75.75 0 011.5 0v12.04a.75.75 0 01-.75.75z","fill":"#A4A8C0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 16.541a.746.746 0 01-.53-.22l-2.917-2.928a.751.751 0 011.062-1.059L12 14.73l2.385-2.395a.749.749 0 111.062 1.06l-2.916 2.926a.746.746 0 01-.53.221z","fill":"#A4A8C0"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"download","maskUnits":"userSpaceOnUse","x":"2","y":"7","width":"20","height":"15"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 7.733h20v13.744H2V7.733z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#download)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.575 21.477H6.435A4.44 4.44 0 012 17.042v-4.885a4.43 4.43 0 014.426-4.424h.941a.75.75 0 010 1.5h-.941A2.927 2.927 0 003.5 12.157v4.885a2.938 2.938 0 002.935 2.935h11.14a2.93 2.93 0 002.925-2.925v-4.884a2.938 2.938 0 00-2.934-2.935h-.932a.75.75 0 010-1.5h.932A4.44 4.44 0 0122 12.168v4.884a4.43 4.43 0 01-4.425 4.425z","fill":"#A4A8C0"}})])])
          )
        }
      }
    